import { ReadonlyArray } from "@morphism/fp";
import React from "react";

import * as Layout from "~/Layout";
import { NotApplicable } from "~/NotApplicable";
import * as Typography from "~/Typography";

import { Image, ImageSizeProps } from "./Image";
import { ImageCarousel } from "./ImageCarousel";

export type ImagesProps = ImageSizeProps & {
  readonly images: readonly string[];
};

export function Images({ images, width, height }: ImagesProps) {
  return !images[0] ? (
    <Layout.Block.Component bottom>
      <Typography.H4.Component bottom>Images</Typography.H4.Component>
      <div style={{ textAlign: "center" }}>
        <NotApplicable>No images available</NotApplicable>
      </div>
    </Layout.Block.Component>
  ) : (
    pipe(
      images,
      ReadonlyArray.mapWithIndex((index, image) => (
        <Image key={index} imageUrl={image} {...{width, height}} />
      )),
      (images) => <ImageCarousel imageComponents={images} maxWidth={width}/>
    )
  );
}
